














































































































































































































































import { Action, Mutation, State, Getter } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  GET_SELECTED_USER,
  GET_SELECTED_BOND,
  GET_USER_BONDS,
  CREATE_BOND,
  UPDATE_BOND,
  UPDATE_SELECTED_BOND,
  UPDATE_CURRENT_USER_TAB,
  FETCH_USER_BONDS_LIST,
  UPDATE_USER_BONDS,
  UPDATE_BOND_LIST,
  GET_LOCALE_TYPES,
} from '@/modules/user/store';
import { bondApi } from '@/api/bond.api';
import { MessageService } from '@/services/messageService';
import { IBond } from '@/models/Bond';
import { IUser, userTabs } from '@/modules/user/models';

@Component
export default class extends Vue {
  public bondModel: any = {
    description: '',
  };
  public valid: boolean = true;
  public saving: boolean = false;
  public snackbar: boolean = false;
  public timeout: number = 9000;
  public snackbarText: string = '';
  public isLoading: boolean = false;
  public isLoadingGroup: boolean = false;
  public isLoadingLocale: boolean = false;
  public isLoadingBpa: boolean = false;
  public model: any = {};
  public modelBpa: any = {};
  public stores: any[] = [];
  public storesBpa: any[] = [];
  public groups: any[] = [];
  public locales: any[] = [];
  public searchStore: string = '';
  public searchGroup: string = '';
  public searchLocale: string = '';
  public searchStoreBpa: string = '';
  public localeTypeSelected: number = 0;
  public selectedBonds: IBond[] = [];
  public headersStores: any[] = [
    { text: 'Tipo Vínculo', value: 'bondtype' },
    { text: 'Valor', value: 'value' },
    { text: 'Descrição', value: 'description' },
    { text: 'Ações', value: '' },
  ];
  public newBond: IBond = {
    idbond: 0,
    bondtype: '',
    name: '',
    isactive: true,
    description: '',
    identifiernumber: '',
    value: '',
    idbondtype: 0,
    idstorebpa: 0,
    valueBpa: '',
    selected: false,
  };

  public obrigatory: any[] = [(v: any) => !!v || 'Campo obrigatório.'];

  public STORE_TYPE = { id: 3, value: 'Loja' };
  public GROUP_TYPE = { id: 2, value: 'Grupo' };
  public LOCALE_TYPE = { id: 1, value: 'Geográfico' };

  public bondTypes: any[] = [
    this.STORE_TYPE,
    this.GROUP_TYPE,
    this.LOCALE_TYPE,
  ];

  @Getter(GET_SELECTED_USER)
  public userSelected: IUser;

  @Getter(GET_SELECTED_BOND)
  public bondSelected: IBond;

  @Getter(GET_LOCALE_TYPES)
  public localeTypes: any[];

  @Getter(GET_USER_BONDS)
  public userBonds: IBond[];

  @Action(CREATE_BOND)
  public createBond: any;

  @Action(UPDATE_SELECTED_BOND)
  public setSelectedBond: any;

  @Action(UPDATE_CURRENT_USER_TAB)
  private setCurrentTab: any;

  @Action(FETCH_USER_BONDS_LIST)
  private getUserBonds: any;

  @Action(UPDATE_USER_BONDS)
  private setUserBonds: any;

  @Action(UPDATE_BOND)
  private updateBond: any;

  @Action(UPDATE_BOND_LIST)
  private updateBondList: any;

  public setBondIdentifier() {
    this.bondSelected.identifiernumber = this.model.id.toString();
    this.bondSelected.value = this.model.name;
  }

  public setBondIdentifierBpa() {
    this.bondSelected.idstorebpa = this.modelBpa.id;
    this.bondSelected.valueBpa = this.modelBpa.name;
  }

  public saveBond() {
    this.addBond(this.userSelected.id);
  }

  public addBond(idUser: number) {
    this.saving = true;

    if (idUser > 0) {
      this.createBond({ idUser, bonds: this.selectedBonds })
        .then((ret: any) => {
          MessageService.Success('Sucesso', 'Operação realizada com sucesso.');
          this.cancelEdit();
        })
        .finally(() => (this.saving = false));
    } else {
      this.updateBondList(this.selectedBonds);
      this.saving = false;
      this.setCurrentTab(userTabs.tabs.listbondtab);
    }
  }

  public resetParameters() {
    MessageService.Success('Sucesso', 'Operação realizada com sucesso.');

    this.setSelectedBond(this.newBond);
    this.setCurrentTab(userTabs.tabs.listbondtab);
  }

  public cancelEdit() {
    this.model = null;
    this.modelBpa = null;
    this.setSelectedBond(this.newBond);
    this.selectedBonds = [];

    this.getUserBonds(this.userSelected.id).then((ret: any) => {
      this.setUserBonds(ret.data);
      this.setCurrentTab(userTabs.tabs.listbondtab);
    });
  }

  public resetData() {
    this.bondSelected.identifiernumber = '';
    this.bondSelected.value = '';
    this.model = null;
    this.modelBpa = null;
  }

  public addBondToList() {
    const newBond = { ...this.bondSelected };

    if (newBond.idbondtype === this.STORE_TYPE.id) {
      if (
        this.userBonds.some((c) => c.idbondtype === this.GROUP_TYPE.id) ||
        this.selectedBonds.some((c) => c.idbondtype === this.GROUP_TYPE.id)
      ) {
        this.snackbar = true;
        this.snackbarText =
          'Não é possível inserir um vínculo de loja pois já existe um vínculo de grupo associado.';
        return;
      }
    }

    if (newBond.idbondtype === this.GROUP_TYPE.id) {
      if (
        this.userBonds.some((c) => c.idbondtype === this.GROUP_TYPE.id) ||
        this.selectedBonds.some((c) => c.idbondtype === this.GROUP_TYPE.id)
      ) {
        this.snackbar = true;
        this.snackbarText = 'Não é possível inserir mais de um vínculo de grupo para o mesmo usuário.';
        return;
      }
      if (
        this.userBonds.some((c) => c.idbondtype === this.STORE_TYPE.id) ||
        this.selectedBonds.some((c) => c.idbondtype === this.STORE_TYPE.id)
      ) {
        this.snackbar = true;
        this.snackbarText = 'Não é possível inserir um vínculo de grupo pois já existe(m) vínculo(s) de loja(s) associado(s).';
        return;
      }
    }

    newBond.bondtype =
      this.bondSelected.idbondtype === this.STORE_TYPE.id
        ? 'Loja'
        : this.bondSelected.idbondtype === this.GROUP_TYPE.id
        ? 'Grupo'
        : 'Geográfico';

    if (this.bondSelected.idbondtype === this.LOCALE_TYPE.id) {
      newBond.identifiernumber = `{"geocode": ${this.model.id}, "idLocaleType": ${this.localeTypeSelected}}`;
    }

    this.selectedBonds.push(newBond);
    this.setSelectedBond({ isactive: true });
    this.model = null;
    this.modelBpa = null;
    this.localeTypeSelected = 0;
  }

  public removeBondFromList(bondToRemove: IBond) {
    const i = this.selectedBonds.indexOf(bondToRemove);
    this.selectedBonds.splice(i, 1);
  }

  @Watch('searchStore')
  public doSearchStore(val: string) {
    console.log(val);
    if (
      this.isLoading ||
      val === '' ||
      val === this.bondSelected.value ||
      val === 'null'
    ) {
      return;
    }
    this.isLoading = true;
    bondApi
      .getStoreByDnOrName(val)
      .then((ret: any) => {
        this.stores = ret.data;
      })
      .catch((error: any) => {
        MessageService.Error('Erro', error);
      })
      .finally(() => (this.isLoading = false));
  }

  @Watch('searchGroup')
  public doSearchGroup(val: string) {
    if (
      this.isLoadingGroup ||
      val === '' ||
      val === this.bondSelected.value ||
      val === 'null'
    ) {
      return;
    }
    this.isLoadingGroup = true;
    bondApi
      .getGroupByName(val)
      .then((ret: any) => {
        this.groups = ret.data;
      })
      .catch((error: any) => {
        MessageService.Error('Erro', error);
      })
      .finally(() => (this.isLoadingGroup = false));
  }

  @Watch('searchLocale')
  public doSearchLocale(val: string) {
    if (
      this.isLoadingLocale ||
      val === '' ||
      val === this.bondSelected.value ||
      val === 'null'
    ) {
      return;
    }
    this.isLoadingLocale = true;
    bondApi
      .getLocaleByTypeAndName(this.localeTypeSelected, val)
      .then((ret: any) => {
        this.locales = ret.data;
      })
      .catch((error: any) => {
        MessageService.Error('Erro', error);
      })
      .finally(() => (this.isLoadingLocale = false));
  }

  @Watch('searchStoreBpa')
  public doSearchStoreBpa(val: string) {
    if (
      this.isLoadingBpa ||
      val === '' ||
      val === this.bondSelected.valueBpa ||
      val === 'null'
    ) {
      return;
    }
    this.isLoadingBpa = true;
    bondApi
      .getBpaStoreByDnOrName(val)
      .then((ret: any) => {
        this.storesBpa = ret.data;
      })
      .catch((error: any) => {
        MessageService.Error('Erro', error);
      })
      .finally(() => (this.isLoadingBpa = false));
  }
}
